import { Component, OnInit } from '@angular/core';
import { Bando } from '../../models/bando';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../service/loader.service';
import { RestService } from '../../service/rest.service';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { api } from '../../../environments/environment';
import { SeoService } from '../../service/seo.service';

@Component({
  selector: 'app-find',
  templateUrl: './find.component.html',
  styles: [],
  standalone: false
})
export class FindComponent implements OnInit {
  constructor(private router: Router, private rest: RestService, private loader: LoaderService, private location: Location, private http: HttpClient, private route: ActivatedRoute, private seo: SeoService) { }
  pageH1: string = "Bandi per l'innovazione";
  pageSubtitle: string = "Imposta i tuoi criteri e lascia che l’intelligenza artificiale faccia il resto";
  isCategoryPage: boolean = false;
  suggestedBandi: any[] = []
  recentdBandi: any[] = []
  showLogout = window.localStorage.getItem('token') ? true : false
  refI = FindComponent

  numberOfFilters = 2
  baseFilters = [{ name: 'Territorio' }, { name: 'Servizi' }, { name: 'Beneficiari' }, { name: 'Tipologia' }, { name: 'Tipo di contributo' }]
  baseFiltersIndex = -1
  normalFilters = [{ name: 'Abbigliamento' }, { name: 'Banche' }, { name: 'Agricoltura' }, { name: 'Tecnologia' }, { name: 'Cultura' }, { name: 'Istruzione' }, { name: 'Salute' }, { name: 'Ristorazione' }, { name: 'Turismo' }, { name: 'Allevamento' }, { name: 'Danza' }, { name: 'Trasporti' }]
  normalFiltersIndexs: number[] = []
  showAllSuggestedBandi = false
  showAllRecentBandi = false
  showFilters = true
  page = 1
  totalPages = 1
  count = 0
  filters: any[] = []
  filtersToApply: any = {
    exact: false
  }
  filteredNotices: any[] = []
  search: string = ''
  resettingFilters = true
  limit = 15
  newFiltersToApply = false
  lastSearch: any[] = [];
  lastSearchSelected: any = null;
  lastSearchEdited: { label: string; value: any; }[] = [];
  currentSearch = { label: 'Contiene', value: false };
  searchList = [{ label: 'Contiene', value: false }, { label: 'Ricerca esatta', value: true }];
  currentStatus = { label: 'Aperto' };
  oldFilters: any
  status = [{ label: 'Aperto' }, { label: 'Chiuso' }, { label: 'In uscita' }, { label: 'Tutti' }]

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      if (data['h1']) {
        this.pageH1 = data['h1'];
      }
      if (data['meta']) {
        this.pageSubtitle = data['meta'];
      }
      this.seo.updateSeo({
        titleSeo: "Cerca Bandi e Finanziamenti | Innovation Plaza",
        metadescription: 'Trova bandi europei, nazionali e regionali per la tua impresa. Accedi alle migliori opportunità di finanziamento con Innovation Plaza.',
        url: 'https://innovationplaza.it/cerca-bando',
        jsonLd: [
          {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": "https://innovationplaza.it/cerca-bando/#webpage",
            "url": "https://innovationplaza.it/cerca-bando/",
            "name": "Bandi e Opportunita di Finanziamento Innovation Plaza",
            "description": "Bandi, call e programmi di finanziamento europei, nazionali e regionali per imprese, startup e istituzioni. Horizon Europe, FESR, FSE, MISE, PAC e programmi operativi regionali.",
            "inLanguage": "it-IT",
            "isPartOf": { "@id": "https://innovationplaza.it/#website" },
            "about": {
              "@type": "Thing",
              "name": "Finanziamenti e Bandi pubblici per l'innovazione"
            },
            "mainEntity": {
              "@type": "ItemList",
              "name": "Programmi di Finanziamento gestiti da Innovation Plaza",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Horizon Europe" },
                { "@type": "ListItem", "position": 2, "name": "Digital Europe Programme" },
                { "@type": "ListItem", "position": 3, "name": "Cooperazione Territoriale Europea (CTE)" },
                { "@type": "ListItem", "position": 4, "name": "Creative Europe" },
                { "@type": "ListItem", "position": 5, "name": "Bandi MISE per R&S" },
                { "@type": "ListItem", "position": 6, "name": "Programmi Operativi Regionali FESR-FSE-FC" },
                { "@type": "ListItem", "position": 7, "name": "Politica Agricola Comune (PAC)" }
              ]
            }
          },
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "@id": "https://innovationplaza.it/cerca-bando/#service",
            "name": "Consulenza Strategica e Direzionale per l'Innovazione",
            "serviceType": "Consulenza di direzione e strategia",
            "description": "Supporto a imprese e istituzioni nei processi di analisi, strategia, marketing e ideazione. Gestione di iniziative complesse di sviluppo locale, territoriale e internazionale.",
            "url": "https://innovationplaza.it/cerca-bando/",
            "provider": { "@id": "https://innovationplaza.it/#organization" },
            "areaServed": { "@type": "Country", "name": "Italia" },
            "audience": {
              "@type": "Audience",
              "audienceType": "Imprese, istituzioni, aspiranti imprenditori"
            }
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://innovationplaza.it/" },
              { "@type": "ListItem", "position": 2, "name": "Cerca Bando", "item": "https://innovationplaza.it/cerca-bando/" }
            ]
          }
        ]
      });
    });

    this.getNotices()
    this.getFilters()
    this.changeFilters({ label: 'Aperto' }, 'status')
    this.changeFilters({ value: 1, label: 'Apertura recente' }, 'order')
    this.applyFilters()
  }

  changeLimit($event: any) {
    this.page = 1
    this.limit = parseInt($event.limit)
    this.applyFilters()
  }

  getFilters() {
    this.loader.on()
    this.rest.get('/notice/filters').subscribe({
      next: (value: any) => {
        for (const key in value) {
          if (!Object.hasOwn(value, key)) continue;
          if (key !== 'status') {
            if (key == 'codiciAteco') {
              let myNewLabels = value[key].map((label: any) => {
                label.name = `${label.name} - ${label.TITOLO_ATECO_2022 ? label.TITOLO_ATECO_2022 : 'NO DESC'}`
                return label
              })
              this.filters.push({
                name: key,
                labels: myNewLabels
              })
            } else {
              this.filters.push({
                name: key,
                labels: value[key]
              })
            }
          } else {
            this.filters.push({
              name: key,
              labels: value[key].map((res: string) => { return { label: res } })
            })
          }
        }
        this.getLastSearch()
        setTimeout(() => {
          this.loader.off()
        }, 0);
      },
      error: (value: any) => {
        this.loader.off(true)
      },
    })
  }

  getLastSearch() {
    this.loader.on()
    if (localStorage.getItem('token')) {
      this.rest.get('/notice/lastsearch').subscribe({
        next: (value: any) => {
          this.lastSearch = value.map((res: any) => {
            res.desc = []
            for (const key in res.payload) {
              if (key == 'exact' || key == 'search' || key == 'status') {
                res.desc.push({ title: (key), desc: `${JSON.stringify(res.payload[key])}` })
              } else {
                let myFilter = this.filters.find((filter: any) => filter.name == key);
                let descKey = ''
                if (res.payload[key]?.length > 0) {
                  res.payload[key].forEach((element: any, index: number) => {
                    descKey = descKey + myFilter.labels.find((label: any) => label.id == element).name + (index + 1 == res.payload[key].length ? '' : ' | ')
                  });
                }
                res.desc.push({ title: (key), desc: descKey })
              }
            }
            res.label = `${new Date(res.createdAt).toLocaleDateString()}-${new Date(res.createdAt).getHours()}:${new Date(res.createdAt).getMinutes() < 10 ? ('0' + new Date(res.createdAt).getMinutes()) : new Date(res.createdAt).getMinutes()}`
            return res
          });
          this.loader.off(true)
        },
        error: (err) => {

        },
      })
    }
  }

  changeFilters(event: any, name: string) {
    if (name == 'status') {
      this.filtersToApply[name] = event.label
    } else {
      if (name == 'exact' || name == 'order') {
        this.filtersToApply[name] = event.value
      } else {
        this.filtersToApply[name] = event
      }
    }
  }

  applyFilters() {
    this.newFiltersToApply = false
    let params: any = {
      search: this.search
    }
    this.numberOfFilters = 0;
    for (const key in this.filtersToApply) {
      if (!Object.hasOwn(this.filtersToApply, key)) continue;
      this.numberOfFilters = this.numberOfFilters + 1
      const element = this.filtersToApply[key];
      params[key] = (key == 'status' || key == 'exact' || key == 'order' || key == 'search') ? element : element.map((res: any) => res?.id)
    }
    this.loader.on()
    if (this.oldFilters) {
      params = this.oldFilters.payload
      this.oldFilters = null
    }

    if (params['regioni'] && params['regioni'].length > 0) {
      const isEstero = params['regioni'].indexOf(91);
      if (isEstero == -1 && params['regioni'].length == 1) {
        params['tipologiaBando'] = [3];
      }
    }
    console.log(params);
    this.rest.post(`/notice/${!localStorage.getItem('token') ? 'search2' : 'search2f'}?page=` + this.page + '&limit=' + this.limit, params
    ).subscribe({
      next: (value: any) => {
        this.totalPages = value.totalPages
        this.count = value.count
        this.filteredNotices = value.data.map((res: any) => {
          res.open = new Date(res.endDate) > new Date()
          let timeOpen = ` - ${new Date(res.startDate).getUTCHours()}:${new Date(res.startDate).getUTCMinutes() < 10 ? '0' + new Date(res.startDate).getUTCMinutes() : new Date(res.startDate).getUTCMinutes()}`
          res.startDate = new Date(res.startDate).getDate() + '/' + (new Date(res.startDate).getMonth() + 1) + '/' + new Date(res.startDate).getFullYear() + (new Date(res.startDate).getUTCHours() > 0 ? timeOpen : '')
          res.endDate = new Date(res.endDate).getDate() + '/' + (new Date(res.endDate).getMonth() + 1) + '/' + new Date(res.endDate).getFullYear()

          return res
        })
        this.loader.off(true)
      },
      error: (value: any) => {
        this.rest.post(`/notice/search2?page=` + this.page + '&limit=' + this.limit, params).subscribe({
          next: (value: any) => {
            this.totalPages = value.totalPages
            this.count = value.count
            this.filteredNotices = value.data.map((res: any) => {
              res.open = new Date(res.endDate) > new Date()
              let timeOpen = ` - ${new Date(res.startDate).getUTCHours()}:${new Date(res.startDate).getUTCMinutes() < 10 ? '0' + new Date(res.startDate).getUTCMinutes() : new Date(res.startDate).getUTCMinutes()}`
              res.startDate = new Date(res.startDate).getDate() + '/' + (new Date(res.startDate).getMonth() + 1) + '/' + new Date(res.startDate).getFullYear() + (new Date(res.startDate).getUTCHours() > 0 ? timeOpen : '')
              res.endDate = new Date(res.endDate).getDate() + '/' + (new Date(res.endDate).getMonth() + 1) + '/' + new Date(res.endDate).getFullYear()

              return res
            })
            this.loader.off(true)
          },
          error: (value: any) => {
            this.loader.off(true)
          },
        })
      },
    })
  }

  updateUserStatus() {
     this.showLogout= !!localStorage.getItem('token');
  }

  applySearch(event: any) {
    this.oldFilters = event;
    console.log(event);
    this.filtersToApply = event.payload;

    for (const key in this.filtersToApply) {
      if (!Object.hasOwn(this.filtersToApply, key)) continue;
      const element = this.filtersToApply[key];
      console.log(key, element);
      if(key == 'search') this.search = element;
      else if(key == 'exact' || key == 'order') this.filtersToApply[key] = element;
    }
  }

  donwloadBandi() {
    this.loader.on()
    let params: any = {
      search: this.search
    }
    this.numberOfFilters = 0
    for (const key in this.filtersToApply) {
      console.log(key);
      if (!Object.hasOwn(this.filtersToApply, key)) continue;
      this.numberOfFilters = this.numberOfFilters + 1
      const element = this.filtersToApply[key];
      console.log(element);
      params[key] = (key == 'status' || key == 'exact' || key == 'order' || key == 'search') ? element : element.map((res: any) => res?.id)
    }

    this.http.post(`${api.baseUrl}/notice/export`, params, {
      responseType: "blob",
      headers: {
        Authorization: `${api.prefixAuthorization} ${localStorage.getItem(
          'token'
        )}`,
      },
    }).subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = url;
      a.download = "export.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      this.loader.off(true);
    });
  }

  getNotices() {
    this.loader.on()
    this.loader.on()
    this.rest.get('/notice/evidence').subscribe({
      next: (value: any) => {
        this.suggestedBandi = value.map((res: any) => {
          res.open = new Date(res.endDate) > new Date()
          res.endDate = new Date(res.endDate).getDate() + '/' + (new Date(res.endDate).getMonth() + 1) + '/' + new Date(res.endDate).getFullYear()

          return res
        })
        this.loader.off(true)
      },
      error: (value: any) => {
        this.loader.off(true)
      },
    })
    this.rest.get('/notice/most').subscribe({
      next: (value: any) => {
        this.recentdBandi = value.map((res: any) => {
          res.open = new Date(res.endDate) > new Date()
          res.endDate = new Date(res.endDate).getDate() + '/' + (new Date(res.endDate).getMonth() + 1) + '/' + new Date(res.endDate).getFullYear()
          return res
        })
        this.loader.off(true)
      },
      error: (value: any) => {
        this.loader.off(true)
      },
    })
  }

  goToBando(idBando: string) {
    this.router.navigate(['bando/' + idBando])
    let containerWeb = document.getElementById('container-web')
    if (containerWeb) {
      containerWeb.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  goToContacts(){
    this.router.navigate(['contatti'])
    this.scrollTop()
  }

  scrollTop(){
    let containerWeb = document.getElementById('container-web')
    if (containerWeb) {
      containerWeb.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  addNormalFilter(index: number) {
    if (this.normalFiltersIndexs.includes(index)) {
      let myIndex = this.normalFiltersIndexs.findIndex((el: any) => el == index)
      this.normalFiltersIndexs.splice(myIndex, 1)
    } else {
      this.normalFiltersIndexs.push(index)
    }
  }

  inputEnter(event: any) {
    if (event.key == 'Enter') {
      this.applyFilters()
    }
  }

  resetFilters() {
    // this.normalFiltersIndexs = []
    // this.baseFiltersIndex = -1
    this.search = ''
    this.filteredNotices = []
    this.filtersToApply = {
      exact:false,
      order:1
    }
    this.page = 1
    this.resettingFilters = false
    setTimeout(() => {
      this.resettingFilters = true
      this.changeFilters({ label: 'Aperto' }, 'status')
      this.applyFilters()
    }, 0);
  }
}
